import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, MenuItem } from '@mui/material';
import { useCartStore } from '../../store/cartStore';

const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Democratic Republic of the Congo',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States of America',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

export default function CartCheckoutPage() {
  const { cartId } = useParams<{ cartId?: string }>();
  const navigate = useNavigate();
  const { cart, loadCartById } = useCartStore();

  useEffect(() => {
    if (cartId) void loadCartById(Number(cartId));
  }, [cartId, loadCartById]);

  const [form, setForm] = useState<any>({
    customerCode: '',
    name: '',
    surname: '',
    company: '',
    address: '',
    city: '',
    zip: '',
    state: '',
    country: 'United States of America',
    telephone: '',
    fax: '',
    email: '',
    website: '',
    vat: '',
    shippingDifferent: false,
    shipping: '',
    paymentTerms: ''
  });

  const required = ['name', 'surname', 'address', 'city', 'zip', 'telephone', 'email'];

  const onChange = (k: string, v: any) => setForm((s: any) => ({ ...s, [k]: v }));

  const onNext = () => {
    for (const k of required) {
      if (!form[k] || String(form[k]).trim() === '') {
        alert(`${k} is required`);
        return;
      }
    }
    const id = cart?.cartId ?? (cartId ? Number(cartId) : null);
    if (!id) return navigate('/cart');
    navigate(`/cart/${id}/checkout/confirm`, { state: { purchaser: form } });
  };

  return (
    <Box sx={{ p: 3, maxWidth: 980, mx: 'auto' }}>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', color: 'text.secondary', fontSize: 13, mb: 1 }}>
          <Typography sx={{ cursor: 'pointer' }}>Cart</Typography>
          <Typography component="span">•</Typography>
          <Typography sx={{ fontWeight: 600, color: 'text.primary' }}>Purchaser Details</Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: 3, flexWrap: 'wrap' }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>Order — Purchaser Details</Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
              Enter purchaser information before moving to order confirmation.
            </Typography>
          </Box>
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, px: 2, py: 1, borderRadius: 10, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main' }} />
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.primary' }}>Secure checkout</Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 3, p: 2, mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
            <Box sx={{ width: 30, height: 30, borderRadius: '50%', display: 'grid', placeItems: 'center', bgcolor: 'primary.main', color: '#fff', fontWeight: 700 }}>1</Box>
            <Box>
              <Typography sx={{ fontSize: 12, fontWeight: 700, color: 'primary.main' }}>Purchaser Details</Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, opacity: 0.65 }}>
            <Box sx={{ width: 30, height: 30, borderRadius: '50%', display: 'grid', placeItems: 'center', border: '1px solid', borderColor: 'divider', color: 'text.secondary' }}>2</Box>
            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>Confirm Order</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, opacity: 0.65 }}>
            <Box sx={{ width: 30, height: 30, borderRadius: '50%', display: 'grid', placeItems: 'center', border: '1px solid', borderColor: 'divider', color: 'text.secondary' }}>3</Box>
            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>Complete</Typography>
          </Box>
        </Box>
      </Box>

      <Paper sx={{ p: 3, borderRadius: 3, boxShadow: '0 10px 24px rgba(10,26,60,0.05)' }}>
        <Box sx={{ display: 'grid', gap: 3 }}>
          <Box>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.main', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2 }}>Contact Information</Typography>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, alignItems: 'start', textAlign: 'left' }}>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1, textAlign: 'left' }}>Customer Code</Typography>
                <TextField size="small" fullWidth value={form.customerCode} onChange={(e) => onChange('customerCode', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1, textAlign: 'left' }}>Name <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required fullWidth value={form.name} onChange={(e) => onChange('name', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1, textAlign: 'left' }}>Surname <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required fullWidth value={form.surname} onChange={(e) => onChange('surname', e.target.value)} />
              </Box>
            </Box>
          </Box>

          <Box sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 3 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.main', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2 }}>Address</Typography>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' } }}>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Company</Typography>
                <TextField size="small" fullWidth value={form.company} onChange={(e) => onChange('company', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Address <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required fullWidth value={form.address} onChange={(e) => onChange('address', e.target.value)} />
              </Box>
            </Box>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, mt: 2 }}>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>City <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required fullWidth value={form.city} onChange={(e) => onChange('city', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>ZIP code <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required fullWidth value={form.zip} onChange={(e) => onChange('zip', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>State / Province</Typography>
                <TextField size="small" fullWidth value={form.state} onChange={(e) => onChange('state', e.target.value)} />
              </Box>
            </Box>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' }, mt: 2 }}>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Country</Typography>
                <TextField size="small" select fullWidth value={form.country} onChange={(e) => onChange('country', e.target.value)}>
                  {countries.map((c) => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                </TextField>
              </Box>
            </Box>
          </Box>

          <Box sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 3 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.main', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2 }}>Communication</Typography>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(4, minmax(0, 1fr))' } }}>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Telephone <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required fullWidth value={form.telephone} onChange={(e) => onChange('telephone', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Fax</Typography>
                <TextField size="small" fullWidth value={form.fax} onChange={(e) => onChange('fax', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>E-mail <Box component="span" sx={{ color: 'error.main' }}>*</Box></Typography>
                <TextField size="small" required type="email" fullWidth value={form.email} onChange={(e) => onChange('email', e.target.value)} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Website</Typography>
                <TextField size="small" fullWidth value={form.website} onChange={(e) => onChange('website', e.target.value)} />
              </Box>
            </Box>
          </Box>

          <Box sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 3 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.main', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2 }}>Billing</Typography>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' } }}>
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>VAT</Typography>
                <TextField size="small" fullWidth value={form.vat} onChange={(e) => onChange('vat', e.target.value)} />
              </Box>
            </Box>
          </Box>

          <Box sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 3 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.main', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2 }}>Additional Information</Typography>
            <TextField size="small" fullWidth multiline minRows={4} value={form.paymentTerms} onChange={(e) => onChange('paymentTerms', e.target.value)} />
          </Box>

          <Box sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Button variant="outlined" onClick={() => navigate(-1)}>Back</Button>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
              <Typography sx={{ fontSize: 12, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'error.main' }} />
                Fields marked <Box component="span" sx={{ color: 'error.main' }}>*</Box> are required
              </Typography>
              <Button variant="contained" onClick={onNext}>Next</Button>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
